import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import { updateMedicineRequestStatusApi } from "../../../services/medicine-tracking.service";

const UpdateMedicineStatusModal = ({
  open,
  onClose,
  trackingId,
  medicineId,
  currentStatus,
  onSuccess,
}) => {
  const allowedStatuses = ["Pending", "Approved", "Rejected"];
  const [status, setStatus] = useState(
    allowedStatuses.includes(currentStatus) ? currentStatus : ""
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setStatus(allowedStatuses.includes(currentStatus) ? currentStatus : "");
  }, [open, currentStatus]);

  const handleSubmit = async () => {
    if (!allowedStatuses.includes(status)) {
      toast.error("Please select a valid status");
      return;
    }
    if (!status) {
      toast.error("Please select a status");
      return;
    }

    setLoading(true);
    try {
      const response = await updateMedicineRequestStatusApi({
        trackingId,
        medicineId,
        status,
      });

      if (response?.success || response?.code === 200) {
        toast.success("Medicine request status updated successfully");
        onSuccess?.();
        onClose();
      } else {
        toast.error(response?.message || "Failed to update status");
      }
    } catch (error) {
      console.error("Error updating medicine status:", error);
      toast.error(error?.message || "An error occurred while updating the status");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Update Medicine Request Status</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Update the status for medicine request
          </Typography>
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              label="Status"
            >
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Approved">Approved</MenuItem>
              <MenuItem value="Rejected">Rejected</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading || !status}
        >
          {loading ? "Updating..." : "Update Status"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateMedicineStatusModal; 